/**
 * Scanning Helpers
 * Provides utility functions to determine if scanning is active
 */

import { SCAN_MODES } from '@/lib/inputMethods';

// All control method values that require scanning
// Includes both userSettings.controlMethod values AND InputMethod enum values from context
const SCANNING_CONTROL_METHODS = [
  // From userSettings.controlMethod
  'external_switch',
  'mouth_gestures', 
  'eye_control',
  'eyecontrol',
  // From InputMethod enum (context)
  'gaze',
  'head',
  'switch',
  'mouth',
];

/**
 * Check if the given control method requires scanning
 * This includes: external_switch, mouth_gestures, eye_control/eyecontrol
 * AND the InputMethod enum values: gaze, head, switch, mouth
 * @param controlMethod - The control method to check (from context or settings)
 */
export function isScanningControlMethod(controlMethod: string | null | undefined): boolean {
  if (!controlMethod) return false;
  return SCANNING_CONTROL_METHODS.includes(controlMethod);
}

/**
 * Determine if scanning mode should be active
 * Checks both the scanMode from context and the controlMethod
 * @param scanMode - The scan mode from context
 * @param controlMethod - The control method from context or userSettings
 */
export function checkIsScanningMode(scanMode: string | null, controlMethod?: string | null): boolean {
  const isControlMethodScanning = controlMethod ? isScanningControlMethod(controlMethod) : false;
  const isScanModeActive = scanMode && scanMode !== SCAN_MODES.NONE;
  
  return isControlMethodScanning || !!isScanModeActive;
}
